import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import moment from 'moment';
import { distinctUntilChanged } from 'rxjs/operators';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { ICONS } from '../../resources/icons';
import { CalendarView } from '../calendar/calendar.component';

@Component({
  standalone: false,
  selector: 'nimbus-calendar-header',
  templateUrl: './calendar-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarHeaderComponent implements OnInit, OnChanges {
  @Output() public dateChange = new EventEmitter<Date>();
  @Output() public viewChange = new EventEmitter<CalendarView>();

  @Input() public view: CalendarView = CalendarView.Week;
  @Input() public viewDate: Date = new Date();

  public CalendarView = CalendarView;

  public views: CalendarView[] = [CalendarView.Day, CalendarView.Week, CalendarView.Month];

  public viewTranslationKeys: Record<CalendarView, TranslationKeys> = {
    [CalendarView.Day]: TranslationKeys.ManageOpeningHoursDay,
    [CalendarView.Month]: TranslationKeys.ManageOpeningHoursMonth,
    [CalendarView.Week]: TranslationKeys.ManageOpeningHoursWeek,
  };

  public TranslationKeys = TranslationKeys;
  public ICONS = ICONS;

  public selectedDateControl: UntypedFormControl = new UntypedFormControl();

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.viewDate && changes.viewDate.currentValue) {
      this.selectedDateControl.setValue(changes.viewDate.currentValue, { emitEvent: false });
    }
  }

  public ngOnInit(): void {
    this.selectedDateControl.valueChanges.pipe(distinctUntilChanged()).subscribe((val) => {
      this.dateChange.emit(val);
    });
  }

  public today(): void {
    this.dateChange.next(new Date());
  }

  public previous(): void {
    this.dateChange.next(moment(this.viewDate).subtract(1, this.view).toDate());
  }

  public next(): void {
    this.dateChange.next(moment(this.viewDate).add(1, this.view).toDate());
  }

  public changeView(view: CalendarView): void {
    this.viewChange.emit(view);
  }
}
